const auth = require('./AuthActions');
const code = require('./CodeActions');
const comic = require('./ComicActions');
const configuration = require('./ConfigurationActions');
const landingPage = require('./LandingPageActions');
const loot = require('./LootActions');
const network = require('./NetworkActions');
const user = require('./UserActions');
const purchase = require('./PurchaseActions');
const statistics = require('./StatisticsActions');
const debug = require('./DebugActions');
const rewardChannel = require('./RewardChannelActions');
const ranking = require('./RankingActions');
const settings = require('./SettingsActions');
const offer = require('./OfferActions');
const userQuotes = require('./UserQuotesActions');
const bannerSlot = require('./BannerSlotActions');
const subscription = require('./SubscriptionActions');
const ticketOffers = require('./TicketOfferActions');
const trading = require('./TradingActions');
const newsFeed = require('./NewsFeedActions');
const daily = require('./DailyQuestsActions');
const dailyProgress = require('./QuestsProgressActions');
const tags = require('./TagActions');
const ephemeralMiscallanea = require('./EphemeralMiscellaneaActions');
const search = require('./SearchActions');
const dailyBoost = require('./DailyBoostActions');
const intervalProgress = require('./IntervalProgressActions');
const { addSearchedPhrase } = require('../slices/searchHistory');

module.exports = {
  auth,
  code,
  comic,
  configuration,
  landingPage,
  loot,
  network,
  user,
  purchase,
  statistics,
  debug,
  rewardChannel,
  ranking,
  settings,
  bannerSlot,
  offer,
  userQuotes,
  subscription,
  ticketOffers,
  trading,
  newsFeed,
  daily,
  dailyProgress,
  tags,
  ephemeralMiscallanea,
  search,
  dailyBoost,
  intervalProgress,
  addSearchedPhrase,
};
